import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    comparisonSubTitle: {
        color: theme.colors.grey800
    },
    bold: {
        fontWeight: theme.fontWeight.semibold
    }
}));

const ComparisonSubTitle = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { className } = props;
    return (
        <Typography className={classNames(classes.comparisonSubTitle, className)}>
            Prices quoted may change based on factors like rounding and further questions asked by the insurer. Results are inclusive of GST & Govt. charges.
            <span className={classes.bold}> The information on this page is subject to exclusions, restrictions, and sub-limits. Please refer to the PDS for details.</span>
        </Typography>
    );
};

ComparisonSubTitle.propTypes = {
    className: PropTypes.string
};

export { ComparisonSubTitle };
